import React from 'react';
import ReactDOM from 'react-dom/client';
import MirrorMirror from './MirrorMirror';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MirrorMirror />
  </React.StrictMode>
);
